// 客户端方法都是异步回调，所以调用后要缓存
const NativeCallbacks = {}
// 超时时长
const timeout = 100000
// 异步方法集
const asyncApis = {
  apis: ['getRefundChangeRules', 'getAccessToken']
}
// 同步方法集，建议同步方法名称带 sync
const syncApis = {
  apis: ['loginSync', 'aliPay', 'wxPay']
}

// 客户端
const appType = () => {
  if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
    return 'iOS'
  } else if (/(Android)/i.test(navigator.userAgent)) {
    return 'Android'
  } else {
    return ''
  }
}

// 客户端回调
window.nativeCallBack = function (data) {
  const { status, result, msg, callbackId } = data
  const callback = NativeCallbacks[callbackId]

  if (callback && callback.timer) {
    clearTimeout(callback.timer)
  }
  if (status === 'success') {
    callback.resolve(result)
  } else {
    callback.reject(new Error(msg))
  }

  delete NativeCallbacks[callbackId]
}

/**
 * 生成调用方法
 */
const apis = {}

// 异步方法，封装成 Promise 异步调用
Object.keys(asyncApis).forEach((group) => {
  if (!apis[group]) {
    apis[group] = {}
  }
  // 生成分组下的方法
  asyncApis[group].forEach((api) => {
    // 如果已注册过同名的方法则跳过
    if (apis[group][api]) {
      return
    }
    // options = { data: { 业务数据 }, timeout: 超时时间，默认100s }
    apis[group][api] = (options = { data: {} }) => {
      return new Promise((resolve, reject) => {
        const callbackId = new Date().getTime() + ''
        const params = {
          callbackId: callbackId,
          ...options.data
        }
        const type = appType()
        if (type === 'Android') {
          window.NativeApi && window.NativeApi[api](JSON.stringify(params))
          const timer = setTimeout(function () {
            reject(new Error('接口超时'))
          }, options.timeout || timeout)

          NativeCallbacks[callbackId] = {
            resolve,
            timer,
            reject
          }
        } else if (type === 'iOS') {
          window.bridge &&
            window.bridge.call(
              api,
              JSON.stringify(params),
              function (responseData) {
                const { status, result, msg } = JSON.parse(responseData)
                if (status === 'success') {
                  resolve(result)
                } else {
                  reject(new Error(msg))
                }
              }
            )
        }
      })
    }
  })
})

// 同步方法，直接调用，单向通信：H5 --> APP
Object.keys(syncApis).forEach((group) => {
  if (!apis[group]) {
    apis[group] = {}
  }
  // 生成分组下的方法
  syncApis[group].forEach((api) => {
    // 如果已注册过同名的方法则跳过
    if (apis[group][api]) {
      return
    }

    apis[group][api] = (data = {}) => {
      if (appType() === 'Android') {
        window.NativeApi && window.NativeApi[api](JSON.stringify(data))
      } else if (appType() === 'iOS') {
        window.bridge && window.bridge.call(api, JSON.stringify(data))
      }
    }
  })
})

export default { ...apis, appType }
